import types from './types';

const initializeFiltering = (entityType, latestDataViewId, isDeleted = false, nonChecked = false) => ({
  type: types.INITIALIZE_FILTERING,
  params: { entityType, latestDataViewId, isDeleted, nonChecked }
});

const getAutoCompleteSuggestionsList = (showPersonalData, inputName, inputValue) => ({
  type: types.GET_AUTO_COMPLETE_SUGGESTIONS,
  params: { inputName, inputValue, showPersonalData }
});

export const applyFilterV2 = (entityType, filterState, filters) => ({
  type: types.APPLY_FILTERS_V2,
  params: {
    entityType,
    filters,
    ...filterState
  }
});

export default {
  initializeFiltering,
  getAutoCompleteSuggestionsList,
  applyFilterV2
};
